<template>
  <div class="untying-phone__box">
    <el-form
      ref="untying-phone"
      label-position="top"
      :model="formData"
      class="untying-phone__form"
      @submit.native.prevent
    >
      <el-form-item class="select_code">
        <el-select
          v-model="formData.status"
          popper-class="code_padding"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in formData.statuses"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
       <p
        class="untying-phone-txt"
        v-show="boundPhone !== ''"
      >{{formData.status === 0 ? '已绑定手机号：': formData.status === 1 ? '登陆邮箱：' : '登陆账号：'}}</p>
      <p
        class="untying-phone-txt"
        v-show="boundPhone !== ''"
      >{{formData.status === 0 ? boundPhone : formData.status === 1 ? email: accountName}}</p>
      <el-form-item 
        prop="code"
        class="msg-code__item"
        type="input"
        :label="formData.status === 0 ? '短信验证码：': formData.status === 1 ? '邮箱验证码：' : '账号密码验证：'"
      >
        <div class="code-input-box" v-if="formData.status === 0">
          <el-input v-model="formData.codeShort" maxlength="6" class="password__input"></el-input>
        </div>
        <div class="code-input-box" v-if="formData.status === 1">
          <el-input v-model="formData.codeMail" maxlength="6" class="password__input"></el-input>
        </div>
        <div class="code-input-box" v-if="formData.status === 2" style="width:210px;">
          <el-input v-model="formData.code" class="password__input" type="password"></el-input>
        </div>
        <el-button @click="$_modify" class="send-code__btn" :disabled="second > 0" v-if="formData.status !== 2">
          <span v-if="second === 0">发送验证码</span>
          <span v-else>重新发送 {{second}}s</span>
        </el-button>
      </el-form-item>
      <el-form-item class="submit__btn">
        <el-button @click="$_submit" class="untying-phone__btn">保存</el-button>
      </el-form-item>
    </el-form>

    <!-- 图形验证码 -->
    <modal-imgcode 
      v-if="modal.show===true && modal.template==='modify'"
      :title="modal.title"
      :modalData="modal.data"
      @callback="$_getPhoneCode"
      @close="$_close"></modal-imgcode>
  </div>
</template>
<script>
import * as Utils from "@/plugins/utils";
import * as TYPES from "@/store/types";
import ModalImgcode from "./modal-imgcode";
import md5 from "md5";
export default {
  name: "untying-phone",
  props: {
    boundPhone: { type: String, default: "" },
    accountName: { type: String, default: "" },
    email: { type: String, default: "" }
  },
  data() {
    return {
      isLoading: false,
      second: 0,
      timer: null,
      formData: {
         statuses: [
          { value: 0, label: "短信验证" },
          { value: 1, label: "邮箱验证" },
          { value: 2, label: "账号密码验证" }
        ],
        status: 0 ,// 0: 短信验证, 1: 邮箱验证, 2: 账号密码验证
        code: "",
        codeShort: "",
        codeMail: "",
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
    };
  },
  computed: {
    aid() {
      return this.$store.getters.aid;
    },
    type() {
      return this.formData.status === 0 ? this.formData.codeShort : this.formData.codeMail; // 1 绑定 2 修改号码
    },
  },
  methods: {
    $_getPhoneCode() {
      if (this.second > 0 || this.isLoading) return false;
      let self = this;
      self.second = 60;
      self.timer = setInterval(() => {
        self.second--;
        if (self.second == 0) {
          clearInterval(self.timer);
        }
      }, 1000);
    },
    $_submit() {
      if (this.isLoading) return false;
      if(this.formData.status === 0 && this.formData.codeShort === ""){
        $MessageBox.alert({ content: "请输入短信验证码" });
        return false;
      }else if(this.formData.status === 1 && this.formData.codeMail === ""){
        $MessageBox.alert({ content: "请输入邮箱验证码" });
        return false;
      }else if(this.formData.status === 2 && this.formData.code === ""){
        $MessageBox.alert({ content: "请输入密码验证码" });
        return false;
      }

      this.$refs["untying-phone"].validate(valid => {
        if (valid) {
          this.isLoading = true;
          let method = "unbindPhone"; // 默认绑定, updatePhone 修改手机号码
          if (this.boundPhone !== "") {
            method = "unbindPhone";
          }
          var postData = {
            aid: this.aid,
            unbindType: this.formData.status,
            code: this.type
          };
          if(this.formData.status === 2){
            var postData = {
              aid: this.aid,
              unbindType: this.formData.status,
              code: md5(this.formData.code)
            };
          }

          let self = this;
          self.$service.post(method, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              let user = this.$store.state.user.user;
              this.$store.commit(
                TYPES.SET_USER,
                Object.assign(user, { phone: self.formData.phone })
              );
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.$emit("callback", "success");
                }
              });
            }
          });
        }
      });
    },
    //图形验证码弹窗
    $_modify() {
      let self = this;
      self.modal.title = "安全验证";
      self.modal.template = "modify";
      self.modal.data = {
        aid: self.aid,
        type: 3,
        phone: self.boundPhone,
        status: self.formData.status,
      }
      self.modal.show = true;
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  components: {
    ModalImgcode
  },
};
</script>

<style lang="scss" scoped>
.untying-phone__form {
  text-align: left;
  line-height: 28px;
  padding: 0 12px;
  .untying-phone-txt {
    height: 30px;
    line-height: 30px;
  }
  .code-input-box {
    width: 120px;
  }
}
.msg-code__item {
  .send-code__btn {
    position: absolute;
    right: 0;
    top: 4px;
    width: 90px;
  }
}
.submit__btn {
  text-align: center;
}
.send-code__btn,
.untying-phone__btn {
  height: 30px;
  background-color: #1895dd;
  border-radius: 3px;
  &:hover:not(.is-disabled) {
    background-color: #4188d0;
  }
  &:focus:not(.is-disabled) {
    background-color: #276eb6;
  }
  &.is-disabled {
    background-color: #d5dce4;
    cursor: not-allowed;
  }
}
.untying-phone__btn {
  width: 80px;
  margin-top: 12px;
}
/deep/ .untying-phone__form .select_code{
  margin-bottom: 10px;
  .el-input__inner {
    width: 210px;
    height: 34px;
    padding: 0px;
    border: 1px solid #a6babf;
    color: rgba(83, 83, 83, 1);
    margin-top: 0px;
    text-indent: 10px;
  }
}
/deep/ .code_padding {
  left: 0px !important;
}
</style>
<style lang="scss">
.untying-phone__form {
  .el-form-item {
    .el-form-item__label {
      font-size: 13px;
      color: #535353;
    }
    &.is-required {
      .el-form-item__label::before {
        content: "";
      }
    }
    .el-select{
      vertical-align: top;
    }
    .el-input__inner {
      // width: 210px;
      height: 30px;
      padding: 4px;
      border: 1px solid #a6babf;
      color: #000;
      margin-top: 4px;
      border-radius: 0;
      font-size: 12px;
      &:focus {
        border-color: #1895dd;
      }
    }
  }
}
.code_padding .el-select-dropdown__list {
  padding: 0px;
}
</style>


